import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ProgressBarService} from './services/progress-bar.service';
import {LoggerService} from './services/logger.service';
import {MaterialModule} from "./modules/material.module";
import {RoutingModule} from "./modules/routing.module";
import {CommonModule} from "@angular/common";
import {NotFoundComponent} from "./components/not-found/not-found.component";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import {NgxMaskModule} from "ngx-mask";
import {ControlMessagesComponent} from "./components/control-messages/control-messages.component";
import {MessageService} from "./services/message.service";
import { CnpjPipe } from './pipes/cnpj.pipe';
import { CepPipe } from './pipes/cep.pipe';
import { CpfPipe } from './pipes/cpf.pipe';
import { TelefonePipe } from './pipes/telefone.pipe';
import { NumericPipe } from './pipes/numeric.pipe';
import {MatPaginatorModule} from '@angular/material/paginator';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
// @ts-ignore
@NgModule({
    imports: [
        ReactiveFormsModule,
        FormsModule,
        MaterialModule,
        RoutingModule,
        CommonModule,
		BrowserAnimationsModule,
		NgxMaskModule.forRoot()
    ],
    declarations: [
        NotFoundComponent,
        NavBarComponent,
        ControlMessagesComponent,
		CnpjPipe,
		CepPipe,
		CpfPipe,
		TelefonePipe,
		NumericPipe,
    ],
    exports: [
        MaterialModule,
        RoutingModule,
		ReactiveFormsModule,
		FormsModule,
		NgxMaskModule,
        NavBarComponent,
        NotFoundComponent,
        ControlMessagesComponent,
		CnpjPipe,
		CepPipe,
		CpfPipe,
		TelefonePipe,
		NumericPipe,
        MatPaginatorModule,
        NgxDatatableModule
    ],
    providers: [
        LoggerService,
        ProgressBarService,
		MessageService,
    ]
})
export class CoreModule {

}
